//Generated File 
export default class EditScreenListLinkType{
	static readonly CriteriField = `CriteriField`;
	static readonly QuestionField = `QuestionField`;
}
